// TODO Change this for a union type.
enum QuestionKey {
  VEHICLE_TYPE = 'vehicleType',
  LOAN_AMOUNT = 'loanAmount',
  MONTHLY_INCOME = 'monthlyIncome',
  DRIVING_LICENCE = 'drivingLicence',
  TITLE = 'title',
  PERSONAL_DETAILS = 'personalDetails',
  CONTACT_NUMBER = 'contactNumber',
  EMAIL_ADDRESS = 'emailAddress',
  MARITAL_STATUS = 'maritalStatus',
  EMPLOYMENT_HISTORY = 'employmentHistory',
  ADDRESS_HISTORY = 'addressHistory',
  GROUPED_QUESTIONS_FOR_REORDERING_CASE = 'groupedQuestionsForReorderingCase',
  DATE_OF_BIRTH = 'dateOfBirth',
  CONTACT_INFO = 'contactInfo',
  REQUIRED_DETAILS = 'requiredDetails'
}

export default QuestionKey
